import React, { useEffect, useState } from 'react';
import { Mail, ArrowRight, Loader2 } from 'lucide-react';
import { useAuthStore } from '../../store/useStore.js';

export default function LoginForm({ onMagicLinkSent, externalError = '' }) {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState(externalError);
  
  const { requestMagicLink, isLoading } = useAuthStore();

  useEffect(() => {
    setError(externalError);
  }, [externalError]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email || !name) {
      setError('Please enter both email and name');
      return;
    }

    try {
      const result = await requestMagicLink(email, name);
      onMagicLinkSent(email, result.devToken);
    } catch (err) {
      setError(err.message || 'Failed to send magic link');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-3 mb-4">
            <Mail className="w-10 h-10 text-indigo-600" />
            <h1 className="text-3xl font-bold text-gray-800">Welcome to AvRi</h1>
          </div>
          <p className="text-gray-600">
            Enter your email to get started with your homebuying journey
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Your Name
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Ava the Awesome"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              disabled={isLoading}
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Email Address
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="ava@example.com"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
              disabled={isLoading}
              required
            />
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-3">
              <p className="text-red-800 text-sm">{error}</p>
            </div>
          )}

          <button
            type="submit"
            disabled={isLoading}
            className="w-full bg-indigo-600 text-white py-3 rounded-lg font-semibold hover:bg-indigo-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors flex items-center justify-center gap-2"
          >
            {isLoading ? (
              <>
                <Loader2 className="w-5 h-5 animate-spin" />
                Sending Magic Link...
              </>
            ) : (
              <>
                Send Magic Link
                <ArrowRight className="w-5 h-5" />
              </>
            )}
          </button>
        </form>

        <div className="mt-6 text-center">
          <p className="text-sm text-gray-600">
            We'll send you a secure login link. No passwords needed! 🎉
          </p>
        </div>
      </div>
    </div>
  );
}
